export const VALIDATION_RULES = {
    first_name: {
      required: true,
      minLength: 2,
      pattern: /^[a-zA-Z\s'-]+$/,
      message: "First name must be at least 2 characters and contain only letters"
    },
    last_name: {
      required: true,
      minLength: 2,
      pattern: /^[a-zA-Z\s'-]+$/,
      message: "Last name must be at least 2 characters and contain only letters"
    },
    email: {
      required: true,
      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Please enter a valid email address"
    },
    username: {
      required: true,
      minLength: 3,
      maxLength: 20,
      pattern: /^[a-zA-Z0-9_-]+$/,
      message: "Username must be 3-20 characters and contain only letters, numbers, _ or -"
    },
    phone_number: {
      required: true,
      pattern: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
      message: "Please enter a valid phone number"
    },
    password: {
      required: true,
      minLength: 8,
      validate: (value) => {
        const hasUpperCase = /[A-Z]/.test(value)
        const hasLowerCase = /[a-z]/.test(value)
        const hasNumbers = /\d/.test(value)
        const hasSpecialChar = /[!@#$%^&*]/.test(value)
        
        if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasSpecialChar) {
          return "Password must contain uppercase, lowercase, numbers, and special characters"
        }
        return true
      }
    },
    password2: {
      required: true,
      validate: (value, formData) => {
        if (value !== formData.password) {
          return "Passwords do not match"
        }
        return true
      }
    }
  }
  
  export const REGISTRATION_STEPS = {
    PERSONAL_INFO: 1,
    CREDENTIALS: 2
  }